// extracted by mini-css-extract-plugin
export default {"pagehome":"homecontent_pagehome__UxuDL","homecontent":"homecontent_homecontent__6W+tp","teaserimage":"homecontent_teaserimage__IbMdx"};